export const CATEGORY_DROPDOWN_MAX_HEIGHT = '244px';

export const SERVICE_MODAL_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
} as const;
